<template>
    <!-- Filters -->
    <Filters :filter-options="filterOptions" @filters-updated="(value) => filtersUpdated(value)" sort="id">
    </Filters>

    <!-- Questions list -->
    <div class="tab-items" v-if="questionsArray.length > 0">
        <div class="accordion" id="questionsList">
            <div class="accordion-item my-4 rounded-2 border" v-for="(question, index) in questionsArray">
                <h2 class="accordion-header" :id="'flush-heading-' + question.id">
                    <button class="accordion-button collapsed shadow-none rounded-2 " type="button"
                        data-bs-toggle="collapse" :data-bs-target="'#flush-collapse-' + question.id"
                        aria-expanded="false" :aria-controls="'#flush-collapse-' + question.id">
                        <span class="one-liner-trimmed pe-4">
                            <span v-html="(index + 1) + '. '"></span>
                            <span v-max-lines="1" v-html="question.description"></span>
                        </span>
                    </button>
                </h2>
                <div :id="'flush-collapse-' + question.id" class="accordion-collapse collapse"
                    :aria-labelledby="'flush-heading-' + question.id" data-bs-parent="#questionsList">
                    <div class="accordion-body">
                        <div class="d-flex flex-wrap gap-3 align-items-center">
                            <span class="badge badge-success">{{ questionTypes[question.question_type] }}</span>
                            <span class="badge badge-danger" v-if="question.skippable === 1">Skippable</span>
                            <p class="d-flex align-items-center m-0 me-auto">
                                <i class="bi bi-clock inline-icon me-1"></i>
                                <span>{{ question.question_time }} sec</span>
                            </p>
                            <div class="d-flex align-items-center gap-2">
                                <button class="btn btn-dark btn-sm" @click="openQuestionModal(question.id)"
                                    v-ripple>Edit</button>
                                <button class="btn btn-danger btn-sm" @click="openDeleteModal(question.id)"
                                    v-ripple>Delete</button>
                            </div>
                        </div>
                        <hr />
	                    <div class="my-3 question_desc_display_block">
	                        <p class="fw-bold m-0" v-html="question.description"></p>
		                    <small class="text-muted" v-html="question.sub_text"></small>
	                    </div>

                        <ul class="list-group" v-if="question.question_type === 'LikertScale'">
                            <li class="list-group-item d-flex align-items-center gap-2" >
                                <i class="bi bi-arrow-right-circle inline-icon"></i> {{ question.min_value }}
                            </li>
	                        <li class="list-group-item d-flex align-items-center gap-2" >
		                        <i class="bi bi-arrow-right-circle inline-icon"></i> {{ question.max_value }}
	                        </li>
                        </ul>
	                    <ul class="list-group" v-else>
		                    <li class="list-group-item d-flex align-items-center gap-2"
		                        v-for="choice in question.choices" :key="'choice_' + choice.id">
			                    <i class="bi bi-arrow-right-circle inline-icon"></i> {{ choice.text }}
		                    </li>
	                    </ul>

                        <p class="fw-bold my-3" v-if="question.parent_questions.length > 0">Parent Questions</p>
                        <ul class="list-group" v-if="question.parent_questions.length > 0">
                            <button class="list-group-item list-group-item-action d-flex align-items-center"
                                v-for="(parent, pindex) in question.parent_questions"
                                :key="'parent_' + index + '_' + parent.id">
                                <span class="one-liner-trimmed"><span v-html="(pindex + 1) + '. '"></span><span
                                        v-html="parent.description"></span></span>
                                <i class="bi bi-pencil hoverable-icon small-icon ms-auto text-primary"
                                    v-tooltip="'Edit Question'" @click="openQuestionModal(parent.id)"></i>
                                <i class="bi bi-x-circle hoverable-icon small-icon ms-2 text-warning"
                                    @click="openRemoveModal(question.id, parent.id, 'parent')"
                                    v-tooltip="'Remove Question'"></i>
                                <i class="bi bi-trash hoverable-icon small-icon ms-2 text-danger"
                                    @click="openDeleteModal(parent.id)" v-tooltip="'Delete Question'"></i>

                            </button>
                        </ul>

                        <p class="fw-bold my-3" v-if="question.child_questions.length > 0">Child Questions</p>
                        <ul class="list-group" v-if="question.child_questions.length > 0">
                            <button class="list-group-item list-group-item-action d-flex align-items-center"
                                v-for="(child, cindex) in question.child_questions"
                                :key="'child_' + index + '_' + child.id">
                                <span class="one-liner-trimmed"><span v-html="(cindex + 1) + '. '"></span><span
                                        v-html="child.description"></span></span>
                                <i class="bi bi-pencil hoverable-icon small-icon ms-auto text-primary"
                                    v-tooltip="'Edit Question'" @click="openQuestionModal(child.id)"></i>
                                <i class="bi bi-x-circle hoverable-icon small-icon ms-2 text-warning"
                                    @click="openRemoveModal(question.id, child.id, 'child')"
                                    v-tooltip="'Remove Question'"></i>
                                <i class="bi bi-trash hoverable-icon small-icon ms-2 text-danger"
                                    @click="openDeleteModal(child.id)" v-tooltip="'Delete Question'"></i>

                            </button>
                        </ul>
                        <p class="fw-bold my-3" v-if="question.variable_name !== 'medication' && question.variable_name !== 'condition_therapy'">Status</p>
                        <div class="d-flex align-items-center gap-3" v-if="question.variable_name !== 'medication' && question.variable_name !== 'condition_therapy'">
                            <div class="custom-switch">
                                <input type="checkbox" class="switch-input" id="question-status"
                                    @change="changeQuestionStatus(question.id)" :checked="question.status === 1" />
                                <label class="switch-label" for="question-status">
                                    <i class="bi bi-check"></i>
                                    <i class="bi bi-x"></i>
                                    <div class="ball"></div>
                                </label>
                            </div>
                            <span>{{ question.status === 1 ? 'Active' : 'Inactive' }}</span>
                        </div>
	                    <p class="fw-bold my-3" v-if="question.variable_name !== 'medication' && question.variable_name !== 'condition_therapy'">Use in Anonymous Survey</p>
	                    <div class="d-flex align-items-center gap-3" v-if="question.variable_name !== 'medication' && question.variable_name !== 'condition_therapy'">
		                    <div class="custom-switch">
			                    <input type="checkbox" class="switch-input" id="question-anonymous"
			                           @change="changeAnonymousStatus(question.id)" :checked="question.anonymous === 1" />
			                    <label class="switch-label" for="question-anonymous">
				                    <i class="bi bi-check"></i>
				                    <i class="bi bi-x"></i>
				                    <div class="ball"></div>
			                    </label>
		                    </div>
		                    <span>{{ question.anonymous === 1 ? 'Yes' : 'No' }}</span>
	                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="questionsLoading">Loading Data ...</div>
    <div v-else-if="questionsArray.length == 0">Nothing Found !</div>
    <div ref="infiniteLoaderContainer" class="d-none infinite-loader-container"></div>

    <ConfirmationModal v-if="showDeleteModal" ref="deleteModal" :title="modal_title_text" :info_text="modal_info_text"
        :icon_class="modal_icon_class" :btn_text="modal_btn_text" :btn_color="modal_btn_color"
        @close-modal="closeDeleteModal" @perform-action="performDeleteAction"></ConfirmationModal>

    <ConfirmationModal v-if="showRemoveModal" ref="removeModal" :title="modal_title_text" :info_text="modal_info_text"
        :icon_class="modal_icon_class" :btn_text="modal_btn_text" :btn_color="modal_btn_color"
        @close-modal="closeRemoveModal" @perform-action="performRemoveAction"></ConfirmationModal>

    <QuestionModal v-if="showQuestionModal" ref="questionModal" :id="questionId" @close-modal="closeQuestionModal"
        @question-added="loadQuestions()" @question-edited="loadQuestions(questionsArray.length, 0)"></QuestionModal>

    <!-- Delete Question Modal -->
    <div class="modal fade" id="delQuestionModal" tabindex="-1" aria-labelledby="delQuestionModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
                    <i class="bi bi-x-circle text-danger w-auto h-auto fs-large"></i>
                    <p class="my-2 fs-3">Are you sure</p>
                    <p class="my-2 text-secondary text-center">You want to delete this question?</p>
                    <div class="mt-3 d-flex gap-3">
                        <button class="btn btn-outline-dark" data-bs-dismiss="modal">Cancel</button>
                        <button class="btn btn-danger" v-ripple data-bs-dismiss="modal">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, inject, watch } from "vue";
import Filters from "@/components/Table/Filters.vue";
import { status_type_options, question_type_options, questionTypes } from '@/utils/questionVariables.js';
import apiClient from "@/utils/axios";
import { useHttpErrorManager } from '@/composables/useHttpErrorManager';
import { useAppHelpers } from '@/composables/useAppHelpers';
import ConfirmationModal from '@/components/GenericModalAndViews/ConfirmationModal.vue';
import QuestionModal from '@/components/Questions/QuestionModal.vue';

const helper = useAppHelpers();
const emits = defineEmits(['questionModalClosed']);

const selectedFilters = ref({});
const filterOptions = ref([
    { label: 'Question Type', type: 'popup', options: question_type_options, filterOn: 'question_type', selected: null, searchMethod: 'exact' },
    { label: 'Status ', type: 'popup', options: status_type_options, filterOn: 'status', selected: null }
]);

const filtersUpdated = (filters) => {
    selectedFilters.value = filters;

    allQuestionsLoaded.value = false;
    if (!questionsLoading.value && !allQuestionsLoaded.value) {
        questionsArray.value = [];
        questionsLoading.value = true;
        helper.loaderOn(infiniteLoaderContainer.value, true);
        loadQuestions();
    }
}

const infiniteLoaderContainer = ref(null);
const questionsLoading = ref(false);
const itemsToLoad = ref(20);

const infiniteContentLoadHandler = () => {
    if (!questionsLoading.value && !allQuestionsLoaded.value && window.scrollY + window.innerHeight >= document.documentElement.scrollHeight) {
        questionsLoading.value = true;
        helper.loaderOn(infiniteLoaderContainer.value, true);
        loadQuestions();
    }
}

const questionsArray = ref([]);
const allQuestionsLoaded = ref(false);
const loadQuestions = async (limit = 0, offset = -1) => {
    let url = "admin/questions";
    try {
        selectedFilters.value['limit'] = limit <= 0 ? itemsToLoad.value : limit;
        selectedFilters.value['offset'] = offset < 0 ? questionsArray.value.length : offset;
        const content = await apiClient.get(url, { params: selectedFilters.value });
        if (content.data.data) {
            if (selectedFilters.value['offset'] === 0) {
                questionsArray.value = [];
            }
            let questionsLoaded = content.data.data.length;
            if (questionsLoaded === 0 || questionsLoaded < itemsToLoad.value) {
                allQuestionsLoaded.value = true;
            }
            content.data.data.forEach((d) => {
                questionsArray.value.push(d);
            });
        }

        setTimeout(() => {
            helper.loaderOff(infiniteLoaderContainer.value, true);
            questionsLoading.value = false;
        }, 1000);
    }
    catch (error) {
        setTimeout(() => {
            helper.loaderOff(infiniteLoaderContainer.value, true);
            questionsLoading.value = false;
        }, 1000);
        let errorObj = await useHttpErrorManager().handleError(error, false);
    }
}

const modal_title_text = ref('');
const modal_info_text = ref('');
const modal_icon_class = ref('');
const modal_btn_text = ref('');
const modal_btn_color = ref('');

const deleteModal = ref(null);
const showDeleteModal = ref(false);
const deleteQuestionId = ref(null);
const openDeleteModal = (id) => {
    deleteQuestionId.value = id;
    modal_title_text.value = "Delete Question";
    modal_info_text.value = "Are you sure you want to delete this question!";
    modal_btn_text.value = "Yes!";
    modal_icon_class.value = "bi-trash text-danger";
    modal_btn_color.value = 'btn-danger';
    showDeleteModal.value = true;
}
const closeDeleteModal = () => {
    deleteQuestionId.value = null;
    modal_title_text.value = "";
    modal_info_text.value = "";
    modal_btn_text.value = "";
    modal_icon_class.value = "";
    modal_btn_color.value = '';
    showDeleteModal.value = false;
}
const performDeleteAction = async () => {
    if (deleteQuestionId.value) {
        let url = "/admin/questions/delete_question/" + deleteQuestionId.value;
        try {
            let response = await apiClient.post(url, {});
            if (response.status === 200) {
                questionsArray.value = questionsArray.value.filter(q => q.id !== deleteQuestionId.value);

                questionsArray.value = questionsArray.value.map(q => {
                    return {
                        ...q,
                        parent: q.parent.filter(item => item.id !== deleteQuestionId.value),
                        child: q.child.filter(item => item.id !== deleteQuestionId.value)
                    };
                });

                deleteModal.value.close();
            }
        }
        catch (error) {
            let errorObj = await useHttpErrorManager().handleError(error, false);
        }
    }
    else {
        deleteModal.value.close();
    }
}

const removeModal = ref(null);
const showRemoveModal = ref(false);
const removeQuestionId = ref(null);
const removeMainQuestionId = ref(null);
const removeType = ref(null);
const openRemoveModal = (qid, id, type) => {
    removeQuestionId.value = id;
    removeMainQuestionId.value = qid;
    removeType.value = type;
    modal_title_text.value = "Remove Question";
    modal_info_text.value = "Are you sure you want to remove the link of this question!";
    modal_btn_text.value = "Yes!";
    modal_icon_class.value = "bi-x-circle text-warning";
    modal_btn_color.value = 'btn-warning';
    showRemoveModal.value = true;
}

const closeRemoveModal = () => {
    removeQuestionId.value = null;
    removeMainQuestionId.value = null;
    removeType.value = null;
    modal_title_text.value = "";
    modal_info_text.value = "";
    modal_btn_text.value = "";
    modal_icon_class.value = "";
    modal_btn_color.value = '';
    showRemoveModal.value = false;
}

const performRemoveAction = async () => {
    if (removeQuestionId.value && removeMainQuestionId.value && removeType.value) {
        let url = "/admin/questions/remove_question/" + removeMainQuestionId.value + "/" + removeQuestionId.value + "/" + removeType.value;
        try {
            let response = await apiClient.post(url, {});
            if (response.status === 200) {
                questionsArray.value = questionsArray.value.map(q => {
                    if (q.id === removeMainQuestionId.id) {
                        return {
                            ...q,
                            parent: q.parent.filter(item => item.id !== removeQuestionId.value),
                            child: q.child.filter(item => item.id !== removeQuestionId.value)
                        };
                    }
                    else {
                        return q;
                    }
                });

                removeModal.value.close();
            }
        }
        catch (error) {
            let errorObj = await useHttpErrorManager().handleError(error, false);
        }
    }
    else {
        removeModal.value.close();
    }
}

const clickedButtonName = inject('clickedTabButtonName');

watch(clickedButtonName, (newVal, oldVal) => {
    if (newVal) {
        if (clickedButtonName.value === 'openQuestionModal' && !showQuestionModal.value) {
            openQuestionModal();
        }
    }
})

const questionModal = ref(null);
const showQuestionModal = ref(false);
const questionId = ref(null);
const openQuestionModal = (id = null) => {
    questionId.value = id;
    showQuestionModal.value = true;
}

const closeQuestionModal = () => {
    questionId.value = null;
    showQuestionModal.value = false;
    emits('questionModalClosed');
}

const changeQuestionStatus = async (id) => {
    let url = "/admin/questions/edit_question/status/" + id;
    try {
        let response = await apiClient.post(url, {});
        if (response.status === 200) {
            questionsArray.value = questionsArray.value.map(q => {
                if (q.id === id) {
                    if (q.status == 0) {
                        q.status = 1;
                    }
                    else {
                        q.status = 0;
                    }
                }
                return q;
            });
        }
    }
    catch (error) {
        let errorObj = await useHttpErrorManager().handleError(error, false);
    }
}

const changeAnonymousStatus = async (id) => {
	let url = "/admin/questions/edit_question/anonymous/" + id;
	try {
		let response = await apiClient.post(url, {});
		if (response.status === 200) {
			questionsArray.value = questionsArray.value.map(q => {
				if (q.id === id) {
					if (q.anonymous === 0) {
						q.anonymous = 1;
					}
					else {
						q.anonymous = 0;
					}
				}
				return q;
			});
		}
	}
	catch (error) {
		let errorObj = await useHttpErrorManager().handleError(error, false);
	}
}

onMounted(() => {
    window.addEventListener('scroll', infiniteContentLoadHandler)

    questionsLoading.value = true;
    helper.loaderOn(infiniteLoaderContainer.value, true);
    loadQuestions();
});

onUnmounted(() => {
    window.removeEventListener('scroll', infiniteContentLoadHandler);
});

</script>

<style lang="scss">
.one-liner-trimmed {
    display: flex;
    gap: 0.5rem;

    p {
        margin: 0 !important;
    }
}
.question_desc_display_block{
	p:first-of-type{
		margin: 0;
	}
}
</style>